/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Balance info per asset for register
 */
export interface AssetBalanceRegisterInfo {
  assetCode?: string;
  total?: number;
}
